import { createContext } from "react";

const defaultValue = {
  favicon: "",
  defaultSeo: {},
};

export const GlobalContext = createContext(defaultValue);
